import { render } from "./OrderCreateBatteryRoiMKB.vue?vue&type=template&id=78aca483"
import script from "./OrderCreateBatteryRoiMKB.vue?vue&type=script&lang=js"
export * from "./OrderCreateBatteryRoiMKB.vue?vue&type=script&lang=js"

import "./OrderCreateBatteryRoiMKB.vue?vue&type=style&index=0&id=78aca483&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__